import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { ordersService } from '../../services/orders.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-view-bidding',
  templateUrl: './view-bidding.component.html',
  styleUrls: ['./view-bidding.component.css']
})
export class ViewBiddingComponent implements OnInit {

  order: any = null;
  vendorBids: any[] = [];
  isLoading = false;

  // Compare popup
  showCompareDialog = false;
  selectedBid: any = null;
  actionLoading = false;
  counterBidForm!: FormGroup;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private ordersService: ordersService,
    private messageService: MessageService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.order = this.config?.data?.order;
    this.buildCounterBidForm();
    if (this.order?.id) {
      this.loadBids(this.order.id);
    }
  }

  loadBids(orderId: any): void {
    this.isLoading = true;
    const filters = [{ key: 'ORDER_ID', value: orderId.toString() }];
    this.ordersService.getVendorOrders(filters, 0, 100, 'id', 'DESC').subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.vendorBids = res?.responseObject?.content || [];
      },
      error: () => {
        this.isLoading = false;
        this.vendorBids = [];
      }
    });
  }


  closeCompare(): void {
    this.showCompareDialog = false;
    this.selectedBid = null;
  }

  buildCounterBidForm(): void {
    this.counterBidForm = this.fb.group({
      counterBidAmount: [null, [Validators.required, Validators.min(1)]],
      counterVehicles:  [1,   [Validators.required, Validators.min(1)]]
    });
  }
  
  openCompare(bid: any): void {
    this.selectedBid = bid;
    // Pre-fill counter bid with current procurement price
    this.counterBidForm.reset({
      counterBidAmount: this.order?.procurementPrice || this.order?.procurementProvidedAmount || null,
      counterVehicles:  this.order?.numberOfVehicles || this.order?.numberOfVehicle || 1
    });
    this.showCompareDialog = true;
  }
  
  onCounterBid(): void {
    if (this.counterBidForm.invalid) {
      this.counterBidForm.markAllAsTouched();
      return;
    }
  
    const formValue = this.counterBidForm.value;
  
    const payload = {
      id:              this.selectedBid.id,
      status:          'PendingOnVendor',       // sends back to vendor
      finalAcceptance: 'CUSTOMER',
      procurementPrice:       formValue.counterBidAmount,
      numberOfVehicle: formValue.counterVehicles
    };
  
    this.actionLoading = true;
  
    this.ordersService.createUpdateOrderBidding(payload).subscribe({
      next: (res: any) => {
        this.actionLoading = false;
        this.showCompareDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res?.responseMessage || 'Counter bid submitted'
        });
        this.loadBids(this.order.id);
      },
      error: (err: any) => {
        this.actionLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.responseMessage || 'Something went wrong'
        });
      }
    });
  }

  onAction(status: 'AcceptedByCustomer' | 'RejectedByCustomer'): void {
    if (!this.selectedBid) return;

    const payload: any = {
      id:              this.selectedBid.id,
      status:          status,
      finalAcceptance: 'VENDOR',
      finalAmount: this.selectedBid.finalAcceptance === 'VENDOR' ? this.selectedBid.bidAmount : this.selectedBid.procurementPrice
    };

    this.actionLoading = true;

    this.ordersService.createUpdateOrderBidding(payload).subscribe({
      next: (res: any) => {
        this.actionLoading = false;
        this.showCompareDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res?.responseMessage || 'Action completed'
        });
        this.loadBids(this.order.id);
      },
      error: (err: any) => {
        this.actionLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.responseMessage || 'Something went wrong'
        });
      }
    });
  }

  statusClass(status: string): string {
    const s = status?.toLowerCase();
    if (s?.includes('accept')) return 'status-accepted';
    if (s?.includes('reject')) return 'status-rejected';
    if (s?.includes('pending')) return 'status-pending';
    return 'status-default';
  }

  statusLabel(status: string): string {
    if (!status) return '--';
    return status.replace(/([A-Z])/g, ' $1').trim();
  }

  onClose(): void {
    this.ref.close();
  }
}